<template>
  <div id="app">
    <!-- <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Chakra+Petch&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@700&display=swap');


#app {
  color: rgb(0, 7, 36);
  font-family: 'Chakra Petch', sans-serif;
}

.bg-light-success {
  background-color: #ccebd3 !important;
}

.swal2-modal, .modal-dialog {
  font-family: 'Chakra Petch', sans-serif !important;
}

img.icon-svg{
  width: 1.25em;
  vertical-align: -0.25em;
}

img.icon-menu-svg {
  width: 1.5em;
  vertical-align: -0.38em;
  filter: drop-shadow(2px 2px 2px #2222225e);
  margin-right: 0.25rem;
}

body {
  background: #efefee;
}

.w-90 {
  width: 90px;
}

.w-110 {
  width: 110px;
}

.w-120 {
  width: 120px;
}

.w-150 {
  width: 150px;
}

.w-240 {
  width: 240px;
}

.bg-gra-ye-gr{
  background-image: linear-gradient(to bottom right, #FFDD9470, #D0E6A570);
}

.bg-gra-ye-or{
  background-image: linear-gradient(to bottom right, #FFDD9470, #e6d1a570);
}

.bg-gra-ye-pu{
  background-image: linear-gradient(to bottom right, #FFDD9470, #CCABD870);
}

.bg-gra-pu-bl{
  background-image: linear-gradient(to bottom right, #CCABD870, #86e3ce70);
}

.bg-gra-gr-bl{
  background-image: linear-gradient(to bottom right, #D0E6A570, #86e3ce70);
}

.border-1r {
  border-width:.1rem !important;
}

.border-purple {
  border-color: #7c00ff !important;
}

.border-transparent-app {
  border-color: transparent !important;
  border-radius: 1rem !important;
}

.text-purple {
  color: #8c00ff !important;
}

.alert-purple {
  color: #580085 !important;
  background-color: #daccff !important;
  border-color: #7c00ff;
}

div.custom-radio-purple .custom-control-input:checked~.custom-control-label:before{
  background-color: #8c00ff !important;
  border-color: #7c00ff !important;
}

.btn-purple {
  color: #fff !important;
  background-color: #8c00ff !important;
  border-color: #7c00ff !important;
}

.btn-purple.focus, .btn-purple:focus, .btn-purple:hover {
  color: #fff !important;
  background-color: #7700d8 !important;
  border-color: #7c00ff !important;
}

.badge-purple {
  color: #fff !important;
  background-color: #8c00ff !important;
}

tr.table-Diamond {
  background-image: linear-gradient(-45deg, #edf7f8aa, #A7F9F9aa, #437ff9aa);
  background-size: 300% 300%;
	animation: gradient_bg 8s ease-in-out infinite alternate;
}

tr.table-Platinum {
  background-image: linear-gradient(-45deg, #D0D1CBaa, #A2A39Daa, #E3E4DFaa);
  background-size: 300% 300%;
	animation: gradient_bg 8s ease-in-out infinite alternate;
}

tr.table-Gold {
  background-image: linear-gradient(-45deg, #F9CE00aa, #FFB403aa, #B78828aa);
  background-size: 300% 300%;
	animation: gradient_bg 8s ease-in-out infinite alternate;
}


tr.table-Diamond td:last-child, tr.table-Platinum td:last-child, tr.table-Gold td:last-child {
  background: #FFF;
}

.animation-cylon {
  transform-origin: center;
  animation: cylon .75s ease-in-out infinite alternate;
  width: 3rem;
  height: 3rem;
}

.w-140{
  width: 140px;
}

.w-min-100{
  width: 100px;
}

.w-min-220{
  width: 220px;
}

@keyframes gradient_bg {
	0% {
		background-position: 0% 50%;
	}
	100% {
		background-position: 100% 50%;
	}
}

@keyframes cylon {
  0% {
    transform: translateX(-25%);
  }
  100% {
    transform: translateX(25%);
  }
}


</style>



// WEBPACK FOOTER //
// src/App.vue